import React, { useContext } from 'react'
import { FaBars } from 'react-icons/fa' // Hamburger icon
import { useNavigate } from 'react-router-dom'
import { MdLogout } from 'react-icons/md'
import { MyContext } from '../../utils/context/TempAuth'

const Header = ({ toggleDrawer }) => {
  const { auth } = useContext(MyContext)
  const firstName = auth.userData.firstName
  return (
    <div className="bg-sky-300 fixed w-full text-white p-4 flex items-center justify-between">
      <div className="flex justify-between w-full items-center">
        <div className="flex items-center gap-4">
          <FaBars
            className="text-2xl cursor-pointer lg:hidden"
            onClick={toggleDrawer}
          />
          <span className="text-xl font-semibold flex items-center gap-4">
            <div>
              <img
                onClick={toggleDrawer}
                src="/Indian-Drivers-logo.png"
                alt="Logo"
                className="h-10 w-auto hover:cursor-pointer"
              />
            </div>
            Indian Drivers
          </span>
        </div>
        <div className="flex gap-4 items-center">
          <span className="text-lg font-semibold">{firstName}</span>
          <div
            className="cursor-pointer"
            onClick={() => {
              auth.logout()
            }}
          >
            <MdLogout size={22} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
